<template>
    <div class="expected" :class="{'err': err}" @click="focusExpectedInput">
        <div class="title">
            代付金額
        </div>
        <div class="input">
            <span v-show="String(value).length > 0">$</span>
            <input type="number" min="0" step="1" :style="expectedInput" :value="value" @input="onInput" @keyup.enter="$event.target.blur()" placeholder="此地點購買商品大約多少錢？" ref="expectedInput">
        </div>
        <div v-show="err">
            <div class="line"></div>
            <span class="err-msg">
                {{ err }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TaskExpectedInput",
        props: {
            value: {
                default: '',
            },
            err: {
                default: '',
            }
        },
        computed: {
            expectedInput() {
                let width = (String(this.value).length / 1.76) + 'em';
                if (String(this.value).length === 0) {
                    return {
                        flex: 1,
                    }
                }

                return {
                    width: width,
                };
            },
        },
        methods: {
            focusExpectedInput() {
                this.$refs.expectedInput.focus()
            },
            onInput(val) {
                let v = val.target.value.trim();
                if (!v) {
                    this.$emit('input', '');
                    val.target.value = '';
                } else if (/^([0-9]+)?$/.test(v)) {
                    this.$emit('input', v);
                } else {
                    val.target.value = this.value;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .expected {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 15px 15px 15px;
        padding: 10px 15px;
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
        cursor: pointer;
        user-select: none;
        position: relative;

        .err-msg {
            position: absolute;
            color: rgba(244,67,54,1) !important;
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px !important;
            left: 15px;
            margin: 0 !important;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 103px;
            bottom: -2px;
            left: 6px;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1);
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35);
        }

        .title {
            color: #339933;
            font-weight: 500;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
        }

        .input {
            margin-left: 15px;
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: baseline;

            span {
                color: #339933;
                line-height: 18px;
            }

            input {
                border: none;
                text-align: right;
                padding: 0;
                color: #339933;

                &::placeholder {
                    color: #339933;
                }

                &::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }

            input[type=number] {
                -moz-appearance: textfield;
            }
        }
    }

</style>